import { render, staticRenderFns } from "./ResponseAlert.vue?vue&type=template&id=67b45771&"
import script from "./ResponseAlert.vue?vue&type=script&lang=js&"
export * from "./ResponseAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports